import React, { useCallback, useEffect, useState } from "react";
import { fetchQuestionDetail } from "@/apis/help/help.api";
import UKDrawer from "@/components/UKDrawer";
import UKPageNothing from "@/components/UKPageNothing";
import { HelpDetailWrapper } from "@/styles/product/index";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
import UKPageError from "@/components/UKPageError";
import RichTextLoading from "./RichTextLoading";
import HistoryIcon from "@/assets/icons/HistoryIcon.svg";
import { useRouter } from 'next/navigation';

interface UKDrawerType {
  id?: string, // 传递参数
  openDrawer: boolean;// 开关
  handleClose: () => void; // 关闭按钮回调
  title?: string;// 标题
  width?: number | string; // 宽度
  height?: number | string; // 高度
  children?: React.ReactNode; //子节点
  className?: string; // 抽屉样式
  showHeader?: boolean; // 显示头
  showTitle?: boolean; // 显示标题
  showCloseButton?: boolean; // 显示关闭按钮
  headerContentStyle?: React.CSSProperties; // 头部样式
  anchor?: "left" | "top" | "right" | "bottom" | undefined; // 抽屉位置 
}

const UKDrawerHelp = ({ 
  id,
  openDrawer,
  width,
  height,
  children,
  className,
  headerContentStyle,
  anchor = "right",
  showHeader = true,
  showTitle = true,
  showCloseButton = true,
  handleClose, }: UKDrawerType) => {
  const [detail, setDetail] = useState<any>(null);
  const [detailLoading, setDetailLoading] = useState<boolean>(false); // 详情加载状态
  const [title, setTitle] = useState<string>('');
  const [scene, setScene] = useState<string>('');
  const [isPageErr, setIsPageErr] = useState<boolean>(false); // 是否页面异常
  const { t } = useTranslation();
  const route = useRouter();
  const handleTryAgain = useCallback(() => {
    if (id) {
      return getDetail(id);
    }
    return null;
  }, [id]);
  // 获取问题详情
  const getDetail = async (id: string) => {
    setDetailLoading(true);
    setIsPageErr(false);
    try {
      const { data, code } = await fetchQuestionDetail({ scene: id });
      setDetailLoading(false);
      if (code === "200") {
        setDetail(data.facadeContent);
        setTitle(data.facadeName);
        setScene(data.scene);
      }
    } catch (error) {
      setIsPageErr(true);
    }
  };
  useEffect(() => {
    if (id) {
      getDetail(id)
    }
  }, [id]);

  const handleToVersion = () => {
    route.replace("/privacy-policy/archive");
  };
  return (
    <UKDrawer 
      openDrawer={openDrawer}
      title={title}
      width={width || 616}
      className={className}
      headerContentStyle={headerContentStyle}
      anchor={anchor}
      showHeader={showHeader}
      showTitle={showTitle}
      showCloseButton={showCloseButton}
      handleClose={handleClose}
      height={height}
      >
      <div className={`${styles.support_wrapper} ${isPageErr ? styles.wrapper_top : ''}`}>
        {isPageErr ? (
          <UKPageError btnText={t("common.btnText.tryAgain")} clickTryAgain={handleTryAgain} />
        ) : (
          <div className={styles.main_wrapper}>
            {detailLoading ? (
              <div className={styles.item_content}>
                <RichTextLoading />
              </div>
            ) : detail ? (
              <div className={styles.item_content}>
                <div className={styles.content_title}>

                  {scene === "privacy-policy" && (
                    <div className={styles.versionIconWrap} onClick={handleToVersion}>
                      <HistoryIcon />
                      <span>{t("privacyPolicy.archivedVersion")}</span>
                    </div>
                  )}
                </div>
                <HelpDetailWrapper dangerouslySetInnerHTML={{ __html: detail }} />
                {children}
              </div>
            ) : (
              <div className={styles["empty-wrapper"]}>
                <UKPageNothing text={t("common.nothingMore")} />
              </div>
            )}
          </div>
        )}
      </div>
    </UKDrawer>

  );
};



export default UKDrawerHelp;
